/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Networks_List_Search_PlaceholderInputs */

const fr_networks_list_search_placeholder = /** @type {(inputs: Networks_List_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher un réseau ou une ville…`)
};

const en_networks_list_search_placeholder = /** @type {(inputs: Networks_List_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search for a network or city…`)
};

/**
* | output |
* | --- |
* | "Search for a network or city…" |
*
* @param {Networks_List_Search_PlaceholderInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const networks_list_search_placeholder = /** @type {((inputs?: Networks_List_Search_PlaceholderInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Networks_List_Search_PlaceholderInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_networks_list_search_placeholder(inputs)
	return en_networks_list_search_placeholder(inputs)
});